/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 11/19/2019
 *
 * @version 0.2
 * Revisions:
 * 11/19/2019 - BW - Initial Creation
 * 11/16/2022 - BW - Modified: _parseQueryString - update split so it does not split on "&" in double quotes
 *
 * Description/Purpose:
 * Payment Auth.Net JS
 ************************************************************** */
import StackTraceError from "component/stack-trace-error/stack-trace-error";
import { COMMON, TAG_DATA } from "page/payment/payment-util";
import ModalUtil from "util/modal-util";
import {
  BANNER_CLASS, BREAKPOINT_WORD, MEDIA_WATCH, PAGE_PARAM, TINGLE,
} from "constant/app-constant";
import CommonUtil from "util/common-util";
import ButtonUtil from "util/button-util";
import PaymentAuthNetTransactResponseDTO from "dto/payment-auth-net-transact-response-dto";
import PaymentAuthNetTransactResponseBillToDTO from "dto/payment-auth-net-transact-response-bill-to-dto";
import ServerUtil from "util/server-util";


export default class PaymentAuthNet {
  /**
   * Constructor
   * @param $form
   * @param modalWindow
   * @param $modalContent
   * @param argument
   * @param options
   * @returns {PaymentAuthNet}
   */
  constructor($form, modalWindow, $modalContent, argument, options = {}) {
    this._$form = $form;
    this._modalWindow = modalWindow;
    this._$modalContent = $modalContent;
    this._argument = argument;

    const defaults = {};
    // extends config
    this.opts = $.extend(true, defaults, options);

    this._init();
    return this;
  }


  /**
   * Init function
   * @returns {Payment}
   */
  _init() {
    try {
      this._setUpVariable();
      this._cacheDom();
      this._registerEvent();
      this._processArgument();
    } catch (e) {
      StackTraceError.processError(e, 'Payment Auth.net - Init');
    }
    return this;
  }


  /**
   * Setup some common vars
   */
  _setUpVariable() {
    return this;
  }


  /**
   * Caches some often used DOM objects
   * @returns {CategoryView}
   * @private
   */
  _cacheDom() {
    try {
      this._$eAct = $(`#${PAGE_PARAM.E_ACT}`);
      this._$eActSave = $(`#${PAGE_PARAM.E_ACT_SAVE}`);
      this._$iFrameCommunicator = $(`#${COMMON.PAYMENT_IFRAME_COMMUNICATOR_NAME}`);
      this._$processBanner = $(`.${BANNER_CLASS.PROCESSING}`);
      this._$modalBox = $(`.${TINGLE.MODAL_BOX_CLASS}`);
      this._$currentBreakpoint = $(`#${MEDIA_WATCH.CURRENT_BREAKPOINT}`);
      this._urlPaymentServlet = TAG_DATA.URL_PAYMENT_SERVLET;
      this._$accountNumber = $(COMMON.ACCOUNT_NUMBER_SELECTOR);
      this._$accountType = $(COMMON.ACCOUNT_TYPE_SELECTOR);
      this._$authorization = $(COMMON.AUTHORIZATION_SELECTOR);
      this._$responseCode = $(COMMON.RESPONSE_CODE_SELECTOR);
      this._$transId = $(COMMON.TRANS_ID_SELECTOR);
      this._$postedDateTime = $(COMMON.POSTED_DATE_TIME_SELECTOR);
      this._$billToFirstName = $(COMMON.BILL_TO_FIRST_NAME_SELECTOR);
      this._$billToLastName = $(COMMON.BILL_TO_LAST_NAME_SELECTOR);
      this._$billToAddress = $(COMMON.BILL_TO_ADDRESS_SELECTOR);
      this._$billToCity = $(COMMON.BILL_TO_CITY_SELECTOR);
      this._$billToState = $(COMMON.BILL_TO_STATE_SELECTOR);
      this._$billToZip = $(COMMON.BILL_TO_ZIP_SELECTOR);
      this._$billToCountry = $(COMMON.BILL_TO_COUNTRY_SELECTOR);
      this._$billToPhone = $(COMMON.BILL_TO_PHONE_SELECTOR);
      this._$totalAmount = $(COMMON.TOTAL_AMOUNT_SELECTOR);
    } catch (e) {
      StackTraceError.processError(e, 'Payment Auth.net - Cache Dom');
    }
    return this;
  }


  /**
   * Register events or DOM event
   * @private
   */
  _registerEvent() {
    return this;
  }

  /**
   * Will process the argument which is the data returned from Auth.net
   * @private
   */
  _processArgument() {
    const paramArr = this._parseQueryString(this._argument.qstr);
    ServerUtil.addServerLog(this._argument.qstr, $(`#${PAGE_PARAM.LOG_FILE_NAME}`).val(), true, 'test')
    ServerUtil.addServerLog(paramArr.response, $(`#${PAGE_PARAM.LOG_FILE_NAME}`).val(), true, 'test')
    const parentFrame = this._argument.parent.split('/')[4];

    // Process the action
    switch (paramArr.action) {
      case "resizeWindow":
        this._resizeWindow(parentFrame, paramArr);
        break;
      case "cancel":
        // Just close the modal window
        this._modalWindow.close();
        break;
      case "transactResponse": {
        const transactResponse = JSON.parse(paramArr.response);
        this._processTransactResponse(transactResponse);
        break;
      }
    }
  }


  /**
   * Will resize the iFrame and dialog window with each resize action
   * @param parentFrame
   * @param $parentFrame
   * @param paramArr
   * @returns
   */
  _resizeWindow(parentFrame, paramArr) {
    // Hide
    this._hidePaymentIFrame();

    // Get the paramArr values
    const height = parseInt(paramArr.height);
    const width = parseInt(paramArr.width);
    let newWidth = 0;
    const breakpoint = this._$currentBreakpoint.val();

    // Want to "reset" the width
    if (breakpoint === BREAKPOINT_WORD.SMALL) {
      if (width > 450) newWidth = 449;
      else newWidth = width;
    } else if (breakpoint === BREAKPOINT_WORD.MEDIUM) {
      newWidth = 449;
    } else newWidth = 695;

    // Set the IFrame dimensions
    this._$iFrameCommunicator.outerHeight(height);
    this._$iFrameCommunicator.outerWidth(newWidth);

    // Show
    this._showPaymentIFrame();

    // Check modal overflow
    ModalUtil.checkOverflow(this._modalWindow);
  }


  /**
   * Will hide the Loading text and show the iFrame
   * @private
   */
  _hidePaymentIFrame() {
    CommonUtil.show(this._$processBanner);
    CommonUtil.hide(this._$modalContent);
    this._$modalBox.css('height', '200px');
  }

  /**
   * Will show the Loading text and hide the iFrame src
   * @private
   */
  _showPaymentIFrame() {
    CommonUtil.hide(this._$processBanner);
    CommonUtil.show(this._$modalContent);
    this._$iFrameCommunicator.src = '';
    this._$modalBox.css('height', 'auto');
  }


  /**
   * Will simply parse the data returned from the communicator
   * @param str
   * @returns {[]}
   * @private
   */
  _parseQueryString(str) {
    this.__parseQueryString = true; // eslint
    const vars = [];
    //const arr = str.split('&');
    const arr = str.split(/&(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/g);
    let pair;
    for (let i = 0; i < arr.length; i++) {
      pair = arr[i].split('=');
      vars[pair[0]] = unescape(pair[1]);
    }
    return vars;
  }


  /**
   * Will process the Authorize.Net successful transaction response.
   * It will send the data to the Payment servlet and then redirect to the paymentSave.jsp page
   * @param transactResponse
   * @private
   */
  _processTransactResponse(transactResponse) {
    // Convert to DTO
    const paymentAuthNetTransactResponseDTO = new PaymentAuthNetTransactResponseDTO(transactResponse);
    const paymentAuthNetTransactResponseBillToDTO = new PaymentAuthNetTransactResponseBillToDTO(
        transactResponse.billTo !== undefined ? transactResponse.billTo : '',
    );

    // Add the transactResponse data to the form so we can submit it
    this._$accountNumber.val(paymentAuthNetTransactResponseDTO.accountNumber);
    this._$accountType.val(paymentAuthNetTransactResponseDTO.accountType);
    this._$authorization.val(paymentAuthNetTransactResponseDTO.authorization);
    this._$responseCode.val(paymentAuthNetTransactResponseDTO.responseCode);
    this._$transId.val(paymentAuthNetTransactResponseDTO.transId);
    this._$postedDateTime.val(paymentAuthNetTransactResponseDTO.dateTime);
    this._$totalAmount.val(paymentAuthNetTransactResponseDTO.totalAmount);

    // If the user is using a saved Payment Method - there won't be any BillTo properties
    if (paymentAuthNetTransactResponseBillToDTO !== undefined) {
      this._$billToFirstName.val(paymentAuthNetTransactResponseBillToDTO.firstName);
      this._$billToLastName.val(paymentAuthNetTransactResponseBillToDTO.lastName);
      this._$billToAddress.val(paymentAuthNetTransactResponseBillToDTO.address);
      this._$billToCity.val(paymentAuthNetTransactResponseBillToDTO.city);
      this._$billToState.val(paymentAuthNetTransactResponseBillToDTO.state);
      this._$billToZip.val(paymentAuthNetTransactResponseBillToDTO.zip);
      this._$billToCountry.val(paymentAuthNetTransactResponseBillToDTO.country);
      this._$billToPhone.val(paymentAuthNetTransactResponseBillToDTO.phoneNumber);
    }

    // Save and submit form
    ButtonUtil.disableButton();
    this._$eAct.val(this._$eActSave.val());
    this._$form.attr('method', 'post');
    this._$form.attr('target', '');
    this._$form.attr('action', this._urlPaymentServlet);
    this._$form.trigger('submit');
  }
}
